import React, { useState, useEffect, useRef } from "react";
import "./Header3.css";
import { useParams } from "react-router";

import logo from "./../../assets/FInalLogo.png";
// import { useSelector } from 'react-redux/es/exports';
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
// Components

import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
// React icons
import { FiLogIn } from "react-icons/fi";
// React Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import Dropdown from "react-bootstrap/Dropdown";
//cookies
import Cookies from "universal-cookie";
import { logout, resetUserdataOperator } from "../../../Redux/userReducer";
import language from "../../../language";
import { MdArrowDropDown } from "react-icons/md";

const Header3 = () => {
  const [status, setStatus] = useState("login");
  const cookies = new Cookies();
  const history = useHistory();
  const dispatch = useDispatch();
  const { token } = useParams();
  const tok = useParams();
  const searchedData = useSelector((state) => state?.userReducer?.searchDataH2);
  const allOperators = useSelector((state) => state?.operators?.operators);
  const priceData = useSelector((state) => state?.userReducer?.priceDataH2);
  const userdata = useSelector(
    (state) => state?.userReducer?.userdataOperator?.user
  );
  const dropdownToggleRef = useRef(null);
  const [navBarFixed, setNavBarFixed] = useState(false);
  const [navBarFixedMob, setNavBarFixedMob] = useState(false);
  const [tooltipContent, setTooltipContent] = useState("");
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true)

  const changeBackground = () => {
    if (window.scrollY >= 80) {
      setNavBarFixed(true);
    } else {
      setNavBarFixed(false);
    }
  };


  const changeBackground1 = () => {
    if (window.scrollY >= 40) {
      setNavBarFixedMob(true);
    } else {
      setNavBarFixedMob(false);
    }
  };


  const isLogin = cookies.get("auth");
  window.addEventListener("scroll", changeBackground);
  window.addEventListener("scroll", changeBackground1);

  const handleDropdownToggle = (nextIsOpen, event, metadata) => {
    // if (!nextIsOpen) {
    //   setStatus("login");
    // }
  };
  const handleLogout = () => {
    Swal.fire({
      icon: "warning",
      title: "Logout",
      text: "Do you really want to Sign-out?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(logout());
        dispatch(resetUserdataOperator());
        history.push("/");
      }
    });
  };


  useEffect(() => {
    if (window.location.pathname.split("/")[3] !== "home") {
      if (dropdownToggleRef.current) {
        dropdownToggleRef.current.click();
      }
      setStatus("forgot");
    }
  }, []);
  let languageSelectedEnglish =
    sessionStorage.getItem("language") === "english" ||
      !sessionStorage.getItem("language")
      ? true
      : false;

  const handleMouseEnter = (content) => {
    setTooltipContent(content);
  };

  const handleMouseLeave = () => {
    setTooltipContent("");
  };

  return (
    <>
      <div className="topWebH3">
        <div className={navBarFixed ? "mainHeader3OnScoll" : "mainHeader3"}>
          <div className="mainHeader3">
            <div className="topLogoHeader3">
              <Link to="/">
                <img
                  src={logo}
                  style={{ cursor: "pointer" }}
                  className="logoMainH3Img"
                />
              </Link>
            </div>

            <div className="right-header-part">
              <div className="linksSection">
                <Dropdown>
                  <Dropdown.Toggle className="OperatorDropOuter">
                    <div className="navLinks">Operators</div>
                    <MdArrowDropDown className="dropSign" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="manageOuter">
                    {allOperators?.map((operator, index) => (
                      <Dropdown.Item className="profileAction">
                        <Link
                          className="linkNo"
                          to={{
                            pathname: "/client/operator-profile",
                            state: { operatorId: operator._id },
                          }}
                        >
                          {operator?.companyname}
                        </Link>
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
                <Link className="navLinks" to="/client/about-us">
                  About Us
                </Link>
                <Link to="/client/faqs" className="navLinks">
                  FAQ
                </Link>
                <Link className="navLinks" to="/client/contact-us">
                  Contact Us
                </Link>
              </div>
              <div className="language">
                <p className="languageSelect">
                  {languageSelectedEnglish
                    ? "Select language:"
                    : language.chooseYourLanguage}
                </p>
                <Dropdown>
                  <Dropdown.Toggle
                    variant="success"
                    // id="dropdown-language"
                    className="langChangeBtn"
                  >
                    English
                  </Dropdown.Toggle>
                  <Dropdown.Menu style={{ marginRight: "5px" }}>
                    {sessionStorage.getItem("language") === "english" ||
                      !sessionStorage.getItem("language") ? (
                      <Dropdown.Item
                        onClick={() => {
                          sessionStorage.setItem("language", "arabic");
                          window.location.reload();
                        }}
                      >
                        Arabic
                      </Dropdown.Item>
                    ) : null}

                    {sessionStorage.getItem("language") === "arabic" ||
                      !sessionStorage.getItem("language") ? (
                      <Dropdown.Item
                        onClick={() => {
                          sessionStorage.setItem("language", "english");
                          window.location.reload();
                        }}
                      >
                        English
                      </Dropdown.Item>
                    ) : null}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              {userdata ? (
                <>
                  <Dropdown>
                    <Dropdown.Toggle className="profilePicOuter">
                      <img
                        src={require("../../assets/dummyImage.jpeg")}
                        className="dummyImage"
                        alt=""
                      />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="manageOuter">
                      <Dropdown.Item className="profileAction">
                        <Link className="linkNo" to="/user/profile">
                          Profile
                        </Link>
                      </Dropdown.Item>
                      <Dropdown.Item className="profileAction">
                        <Link className="linkNo" to="/user/mybookings">
                          My Bookings
                        </Link>
                      </Dropdown.Item>
                      <Dropdown.Item
                        className="profileAction"
                        onClick={handleLogout}
                      >
                        Logout
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </>
              ) : (
                <div className="login-button">
                  <Dropdown onToggle={handleDropdownToggle}>
                    <Dropdown.Toggle
                      id="dropdown-basic"
                      ref={dropdownToggleRef}
                    >
                      <div className="login-button-inner">
                        <Link to="/client/login" className="linkNo">
                          {languageSelectedEnglish ? "Login" : language.login}
                        </Link>{" "} / {" "}
                        <Link to="/client/sign-up" className="linkNo">
                          {languageSelectedEnglish ? "Sign-up" : language.login}
                        </Link>
                      </div>
                    </Dropdown.Toggle>
                  </Dropdown>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Mobile View */}
      <div className={`${navBarFixedMob ? "topMobileViewH3 " : "topMobileViewH3 "}`}>
        {[false].map((expand) => (
          <Navbar
            key={expand}
            bg="light"
            expand={expand}
            className={`mb-3 ${navBarFixedMob ? "topMobileViewH3scroll" : ""}`}
            fixed="top"
          >
            <Container fluid>
              <Navbar.Brand href="#">
                <Link to="/">
                  <img
                    src={logo}
                    style={{ cursor: "pointer" }}
                    className="logoMainH3Img"
                  />
                </Link>
              </Navbar.Brand>
              <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} className='togl' onClick={handleShow} >
                <div className='line1'></div>
                <div className='line1'></div>
                <div className='line1'></div>
              </Navbar.Toggle>
              <Navbar.Offcanvas
                id={`offcanvasNavbar-expand-${expand}`}
                aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                placement="end"
                show={showOffcanvas}
                onHide={handleClose}
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                    Offcanvas
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className="justify-content-end flex-grow-1 ">
                    <div className="flex flex-col items-start justify-center">
                      <Dropdown className="dropdownNavbar">
                        <Dropdown.Toggle className="OperatorDropOuter">
                          <div className="navLinks">Operators</div>
                          <MdArrowDropDown className="dropSign" />
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="">
                          {allOperators?.map((operator, index) => (
                            <Dropdown.Item className="profileAction">
                              <Link
                                className="linkNo"
                                to={{
                                  pathname: "/client/operator-profile",
                                  state: { operatorId: operator._id },
                                }}
                                onClick={handleClose}
                              >
                                {operator?.companyname}
                              </Link>
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                      <Link
                        className="navLinks offcanLinks"
                        to="/client/about-us"
                        onClick={handleClose}
                      >
                        About Us
                      </Link>
                      <Link to="/client/faqs" className="navLinks offcanLinks" onClick={handleClose}>
                        FAQ
                      </Link>
                      <Link
                        className="navLinks offcanLinks"
                        to="/client/contact-us"
                        onClick={handleClose}
                      >
                        Contact Us
                      </Link>
                    </div>
                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
              <div className="offLanuage">
                <div className="language ">
                  <p style={{ color: "5D0139" }} className="languageText">
                    Select language:
                  </p>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="success"
                      // id="dropdown-language"
                      className="langChangeBtn"
                    >
                      English
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="navMenu">
                      {sessionStorage.getItem("language") === "english" ||
                        !sessionStorage.getItem("language") ? (
                        <Dropdown.Item
                          onClick={() => {
                            sessionStorage.setItem("language", "arabic");
                            window.location.reload();
                          }}
                        >
                          Arabic
                        </Dropdown.Item>
                      ) : null}

                      {sessionStorage.getItem("language") === "arabic" ||
                        !sessionStorage.getItem("language") ? (
                        <Dropdown.Item
                          onClick={() => {
                            sessionStorage.setItem("language", "english");
                            window.location.reload();
                          }}
                        >
                          English
                        </Dropdown.Item>
                      ) : null}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                {userdata ? (
                  <>
                    <Dropdown>
                      <Dropdown.Toggle className="profilePicOuter">
                        <img
                          src={require("../../assets/dummyImage.jpeg")}
                          className="dummyImage"
                          alt=""
                        />
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="manageOuter">
                        <Dropdown.Item className="profileAction">
                          <Link className="linkNo" to="/user/profile">
                            Profile
                          </Link>
                        </Dropdown.Item>
                        <Dropdown.Item className="profileAction">
                          <Link className="linkNo" to="/user/mybookings">
                            My Bookings
                          </Link>
                        </Dropdown.Item>
                        <Dropdown.Item
                          className="profileAction"
                          onClick={handleLogout}
                        >
                          Logout
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </>
                ) : (
                  <div className="login-button">
                    <Dropdown onToggle={handleDropdownToggle}>
                      {" "}
                      <Dropdown.Toggle
                        id="dropdown-basic"
                        ref={dropdownToggleRef}
                      >
                        <Link to="/client/login">
                          <button className="login-button-inner">
                            <div className="btn-text">
                              {languageSelectedEnglish
                                ? "Login"
                                : language.login}
                            </div>
                            <div className="btn-icon">
                              <FiLogIn style={{ fontSize: "10px" }} />
                            </div>
                          </button>
                        </Link>{" "}
                      </Dropdown.Toggle>
                    </Dropdown>
                  </div>
                )}
              </div>
            </Container>
          </Navbar>
        ))}
      </div>
    </>
  );
};

export default Header3;
